(() => {
  const root = document.querySelector('.heritage-lookbook');
  if (!root) return;

  const pad = (number) => String(number).padStart(2, '0');
  const target = new Date(root.dataset.launchTime || '2026-07-31T16:00:00Z').getTime();
  const clock = root.querySelector('.heritage-clock');
  const complete = root.querySelector('.heritage-countdown-complete');

  const updateClock = () => {
    const remaining = Math.max(0, target - Date.now());
    if (remaining <= 0) {
      if (clock) clock.hidden = true;
      if (complete) complete.hidden = false;
      return;
    }
    const values = {
      days: Math.floor(remaining / 86400000),
      hours: Math.floor((remaining / 3600000) % 24),
      minutes: Math.floor((remaining / 60000) % 60),
      seconds: Math.floor((remaining / 1000) % 60)
    };
    Object.entries(values).forEach(([unit, value]) => {
      const element = root.querySelector(`[data-unit="${unit}"]`);
      if (element) element.textContent = pad(value);
    });
  };
  updateClock();
  window.setInterval(updateClock, 1000);

  const menu = root.querySelector('.heritage-menu');
  const nav = root.querySelector('.heritage-nav');
  menu?.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') === 'true';
    menu.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('is-open', !open);
  });
  nav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
    menu?.setAttribute('aria-expanded', 'false');
    nav.classList.remove('is-open');
  }));

  const productData = JSON.parse(root.querySelector('[data-heritage-products]')?.textContent || '[]');
  const modal = root.querySelector('.heritage-modal');
  let activeProduct = null;
  let activeImageIndex = 0;

  const renderGallery = () => {
    if (!activeProduct || !modal) return;
    const images = activeProduct.images || [];
    const image = modal.querySelector('[data-modal-image]');
    image.src = images[activeImageIndex];
    image.alt = `${activeProduct.family} ${activeProduct.name}, view ${activeImageIndex + 1} of ${images.length}`;
    modal.querySelector('[data-gallery-current]').textContent = activeImageIndex + 1;
    modal.querySelector('[data-gallery-total]').textContent = images.length;
    modal.querySelectorAll('[data-gallery-index]').forEach((thumbnail) => {
      const selected = Number(thumbnail.dataset.galleryIndex) === activeImageIndex;
      thumbnail.classList.toggle('is-active', selected);
      thumbnail.setAttribute('aria-current', selected ? 'true' : 'false');
    });
  };

  const moveGallery = (direction) => {
    if (!activeProduct?.images?.length) return;
    activeImageIndex = (activeImageIndex + direction + activeProduct.images.length) % activeProduct.images.length;
    renderGallery();
  };
  const close = () => {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  };
  const open = (id) => {
    const product = productData.find((item) => item.id === id);
    if (!product || !modal) return;
    activeProduct = product;
    activeImageIndex = 0;
    modal.querySelector('[data-modal-number]').textContent = product.number;
    modal.querySelector('[data-modal-family]').textContent = product.family;
    modal.querySelector('[data-modal-name]').textContent = product.name;
    modal.querySelector('[data-modal-statement]').textContent = product.statement;
    modal.querySelector('[data-modal-description]').textContent = product.description;
    const thumbnails = modal.querySelector('[data-modal-thumbnails]');
    thumbnails.replaceChildren(...product.images.map((source, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.galleryIndex = index;
      button.setAttribute('aria-label', `Show image ${index + 1} of ${product.images.length}`);
      const thumbnail = document.createElement('img');
      thumbnail.src = source;
      thumbnail.alt = '';
      button.appendChild(thumbnail);
      button.addEventListener('click', () => {
        activeImageIndex = index;
        renderGallery();
      });
      return button;
    }));
    const list = modal.querySelector('[data-modal-details]');
    list.replaceChildren(...product.details.map((detail) => {
      const item = document.createElement('li');
      item.textContent = detail;
      return item;
    }));
    renderGallery();
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    modal.querySelector('.heritage-modal-close')?.focus();
  };

  root.querySelectorAll('[data-product]').forEach((button) => button.addEventListener('click', () => open(button.dataset.product)));
  modal?.querySelector('.heritage-gallery-prev')?.addEventListener('click', () => moveGallery(-1));
  modal?.querySelector('.heritage-gallery-next')?.addEventListener('click', () => moveGallery(1));
  modal?.querySelector('.heritage-modal-close')?.addEventListener('click', close);
  modal?.addEventListener('click', (event) => { if (event.target === modal) close(); });
  document.addEventListener('keydown', (event) => {
    if (!modal || modal.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') moveGallery(-1);
    if (event.key === 'ArrowRight') moveGallery(1);
  });

  let touchStartX = 0;
  modal?.querySelector('.heritage-modal-image')?.addEventListener('touchstart', (event) => {
    touchStartX = event.changedTouches[0].clientX;
  }, { passive: true });
  modal?.querySelector('.heritage-modal-image')?.addEventListener('touchend', (event) => {
    const distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) > 45) moveGallery(distance > 0 ? -1 : 1);
  }, { passive: true });
})();
